import AuthenticationContext from "adal-angular/lib/adal";

export default {
  logout: function(clientId) {
    var authContext = new AuthenticationContext({
      clientId: clientId,
      popUp: true,
      callback: () => {},
    });
    authContext.clearCache();
    authContext.logOut();
  },
  /**
   * 取得トークン情報をDeSerializeします。
   */
  getResponse: (context, token) => {
    if (token) {
      const parsedJson = context._extractIdToken(token);
      if (parsedJson && parsedJson.exp) {
        const expDate = parsedJson.exp * 1000;
        return {
          accessToken: token,
          expiresOn: expDate,
          upn: parsedJson.upn,
        };
      } else return null;
    } else return null;
  },

  /**
   * ログイン後のコールバック判定
   * なぜか ハッシュ無しのことがある
   * @returns ture = ログインコールバックと判定
   */
  handleWindowCallback: function(clientId) {
    const context = new AuthenticationContext({
      clientId,
    });
    if (context.isCallback(window.location.hash)) {
      context.handleWindowCallback(window.location.hash);
      return true;
    }
    return false;
  },

  /**
   * AzureADで認証を実施します。
   */
  authenticate: function(
    authority,
    resourceUri,
    clientId,
    redirectUri,
    account,
    authCompletedCallback,
    errorCallback
  ) {
    const tid = authority.split("/").slice(-1)[0];
    const _this = this;
    const params = `login_hint=${encodeURIComponent(account)}`;
    const context = new AuthenticationContext({
      tenant: tid,
      clientId: clientId,
      popUp: false,
      loginResource: redirectUri,
      cacheLocation: "localStorage",
      callback: () => {
        _this.getToken(
          context,
          resourceUri,
          authCompletedCallback,
          errorCallback
        );
      },
      navigateToLoginRequestUrl: false,
      extraQueryParameter: params,
    });
    var user = context.getCachedUser();
    if (user) {
      _this.getToken(
        context,
        resourceUri,
        authCompletedCallback,
        errorCallback
      );
    } else {
      context.login();
    }
  },
  getToken(context, resourceUri, successCallback, errorCallback) {
    const _this = this;
    context.acquireToken(resourceUri, function(errorDesc, token, error) {
      if (error) {
        context.acquireTokenPopup(resourceUri, null, null, function(
          errorDesc,
          token,
          error
        ) {
          if (error) {
            errorCallback(error);
          } else {
            successCallback(_this.getResponse(context, token));
          }
        });
      } else {
        successCallback(_this.getResponse(context, token));
      }
    });
  },
};
